export default "__VITE_ASSET__coQD1lZH__"